import type { StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import { TimelineItem } from "./timeline-item";
import { TimelineView } from "./timeline.view";

export const TimelineLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { children: sets, settings: comboSettings, id: comboId } = entity;

  return (
    <TimelineView entity={entity}>
      {sets.map((set, idx) => (
        <TimelineItem key={set.id} itemIdx={idx} setSettings={set.settings}>
          <Set
            entity={{
              ...set,
              layers: {
                ...(entity.layers || {}),
                combo: { settings: comboSettings, idx, id: comboId },
              },
            }}
          />
        </TimelineItem>
      ))}
    </TimelineView>
  );
};
